import { render } from "./AtestatExpert.vue?vue&type=template&id=d8a89086"
import script from "./AtestatExpert.vue?vue&type=script&lang=js"
export * from "./AtestatExpert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__